import script from "./AvatarComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./AvatarComponent.vue?vue&type=script&setup=true&lang=js"

import "./AvatarComponent.vue?vue&type=style&index=0&id=760509f4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-760509f4"]])

export default __exports__